import * as React from 'react';
import {  Route, RouteProps, Redirect } from 'react-router';
import { AppState } from '../store/configureStore';
import { connect } from 'react-redux';
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { helperActionCreators } from '../store/HelperStore';
import { dcrActionCreators } from '../store/DCRStore';
import {Path} from '../App';
import Logout from './pages/Logout';

type TProtectedRouteProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
function ProtectedRoute (props: TProtectedRouteProps) {
    const xspNavigateURL: string = props.xspURL ? props.xspURL : Path.Logout;
    if (props.protectedRouteProps.path !== Path.Default) {
        if (!props.dcr.authenticated) {
            props.logout();
            return <Route path={Path.Logout} component={Logout} />
        } else {
            return <Route path={props.protectedRouteProps.path} component={props.protectedRouteProps.component} />;
        } 
    }
    else {
        return props.dcr.authenticated ? (
            <Redirect exact from={props.protectedRouteProps.path}  to={Path.ContributionHistory} />
            ) : (
            <Route exact path={props.protectedRouteProps.path} render={() => (window.location.href = xspNavigateURL)} />
          )        
    }       
}

  function mapStateToProps(state: AppState, ownProps: RouteProps) {
    return {
        dcr: state.dcr,
        protectedRouteProps: ownProps,
        xspURL: state.helper.xspURLReponseInfo?.url
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...dcrActionCreators,
            ...helperActionCreators
        }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProtectedRoute);  